module.exports = __webpack_public_path__ + "img/hotel-detail-white-bg.f54862c0.png";